export default "__VITE_ASSET__D9YXDp7L__"